import styled from 'styled-components';
import theme from 'styled-theming';
import { prefix } from '../../../tools/settings';
import Carousel from '../../Carousel';
import Scrollable from '../../Scrollable';
var Slider = styled(Carousel).withConfig({
  displayName: "Carouselstyles__Slider",
  componentId: "sc-m24xaq-0"
})(["z-index:2;.", "-carousel{height:", ";}"], prefix, theme('level', {
  one: '600px',
  two: '500px'
}));
var SlideContent = styled.div.withConfig({
  displayName: "Carouselstyles__SlideContent",
  componentId: "sc-m24xaq-1"
})(["display:flex;width:100%;height:100%;"]);
var Body = styled.div.withConfig({
  displayName: "Carouselstyles__Body",
  componentId: "sc-m24xaq-2"
})(["z-index:2;width:56vw;padding:var(--dentsu-spacing-80);display:flex;flex-direction:column;margin-bottom:var(--dentsu-spacing-64);"]);
var Image = styled.div.withConfig({
  displayName: "Carouselstyles__Image",
  componentId: "sc-m24xaq-3"
})(["position:relative;z-index:3;width:100%;display:flex;padding:5vw 5vw 5vw 2vw;img{display:block;margin:auto auto auto 0;width:100%;height:100%;object-fit:contain;object-position:left;}"]);
var Counter = styled.div.withConfig({
  displayName: "Carouselstyles__Counter",
  componentId: "sc-m24xaq-4"
})(["color:", ";font-weight:var(--dentsu-font-weight-regular);font-size:var(--dentsu-font-size-14);line-height:var(--dentsu-leading-normal);margin-bottom:var(--dentsu-spacing-4);opacity:0;transition-duration:0.3s;transition-timing-function:ease;.", "-carousel__slide--active &{opacity:1;}"], theme('level', {
  one: 'var(--dentsu-color-white)',
  two: 'var(--dentsu-color-n1000)'
}), prefix);
var Title = styled.h3.withConfig({
  displayName: "Carouselstyles__Title",
  componentId: "sc-m24xaq-5"
})(["color:", ";font-weight:var(--dentsu-font-weight-bold);font-size:", ";line-height:var(--dentsu-leading-tight);margin-bottom:var(--dentsu-spacing-16);@media (min-width:1440px){font-size:", ";}"], theme('level', {
  one: 'var(--dentsu-color-white)',
  two: 'var(--dentsu-color-n1000)'
}), theme('level', {
  one: 'var(--dentsu-font-size-32)',
  two: 'var(--dentsu-font-size-20)'
}), theme('level', {
  one: 'var(--dentsu-font-size-42)',
  two: 'var(--dentsu-font-size-24)'
}));
var Description = styled.div.withConfig({
  displayName: "Carouselstyles__Description",
  componentId: "sc-m24xaq-6"
})(["border-top:1px solid ", ";padding-top:var(--dentsu-spacing-16);padding-bottom:var(--dentsu-spacing-16);display:flex;flex-direction:column;flex:1;.", "-featureheader__slide--hasStartAction &{border-top:none;border-bottom:none;padding-top:0;padding-bottom:0;}"], theme('level', {
  one: 'var(--dentsu-color-n600)',
  two: 'var(--dentsu-color-n300)'
}), prefix);
var ScrollPane = styled(Scrollable).withConfig({
  displayName: "Carouselstyles__ScrollPane",
  componentId: "sc-m24xaq-7"
})(["color:", ";font-weight:var(--dentsu-font-weight-regular);font-size:", ";line-height:var(--dentsu-leading-normal);padding-right:var(--dentsu-spacing-24);display:block;height:100%;width:100%;p{margin-bottom:var(--dentsu-spacing-12);}.os-scrollbar-track{background:", ";}.os-scrollbar-handle{background:", ";opacity:1 !important;}.os-scrollbar-vertical{background:transparent !important;}@media (min-width:1440px){font-size:", ";}"], theme('level', {
  one: 'var(--dentsu-color-white)',
  two: 'var(--dentsu-color-n1000)'
}), theme('level', {
  one: 'var(--dentsu-font-size-16)',
  two: 'var(--dentsu-font-size-14)'
}), theme('level', {
  one: 'var(--dentsu-color-n600) !important',
  two: 'var(--dentsu-color-n300) !important'
}), theme('level', {
  one: 'var(--dentsu-color-n150) !important',
  two: 'var(--dentsu-color-n700) !important'
}), theme('level', {
  one: 'var(--dentsu-font-size-16)',
  two: 'var(--dentsu-font-size-16)'
}));
export var Styled = {
  Slider: Slider,
  SlideContent: SlideContent,
  Body: Body,
  Image: Image,
  Counter: Counter,
  Title: Title,
  Description: Description,
  ScrollPane: ScrollPane
};